import { Component, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { NGXLogger as LoggerService } from "ngx-logger";

@Component({
    templateUrl: './404.page.html',
    styles: [`
  `]
})
export class Error404Page implements OnInit {
    constructor(
        private swUpdate: SwUpdate,
        private logger: LoggerService,
    ) {}

    ngOnInit() {
        this.checkForSwUpdate();
    }

    private async checkForSwUpdate() {
        if (!this.swUpdate.isEnabled) {
            return;
        }
        try {
            const updateFound = await this.swUpdate.checkForUpdate();
            if (updateFound) {
                this.logger.warn('404 page: SW update found, reloading');
                document.location.reload();
            }
        } catch (err) {
            this.logger.error('404 page: SW update check failed', err);
        }
    }
}
